import { StackProps, Text, VStack } from '@chakra-ui/react';
import { NftAttribute } from '../types/nft';
import TinyHeading from './TinyHeading';

type AttributeProps = StackProps & {
  attribute: NftAttribute;
};

const Attribute = ({ attribute, ...rest }: AttributeProps) => (
  <VStack
    bg="dark.600"
    p="3"
    spacing="1"
    align="start"
    overflow="hidden"
    borderRadius="md"
    {...rest}
  >
    <TinyHeading noOfLines={1}>{attribute.trait_type}</TinyHeading>

    <Text w="full" lineHeight="1.25" noOfLines={1} fontSize="sm">
      {attribute.display_type === 'date'
        ? new Date(+attribute.value).toLocaleDateString()
        : attribute.value}
    </Text>
  </VStack>
);

export default Attribute;
